// The team question, asked the same way on both sign-up paths.
//
// Three answers, not two: start a team, join one that exists, or let the club
// place you. They are one dropdown rather than a radio group plus a select,
// because the middle answer is a list of teams and splitting it puts the same
// decision in two controls.
//
// Sentinels rather than '' for the two non-team answers: MUI renders an empty
// value as a blank field, so "free agent" — the default, and the most common
// answer — looked like nothing had been chosen.

export const FREE_AGENT = '__free_agent__';
export const NEW_TEAM = '__new_team__';
// "Join an existing team" is its own answer rather than one entry per team,
// because the list of teams grows all season and a dropdown that mixes three
// kinds of answer with fifteen team names stops reading as a question.
// Picking it and naming no team is deliberately allowed: that is a player
// saying "I want to be on a team, I just don't know whose yet", which is the
// free-agent pool captains recruit from.
export const JOIN_TEAM = '__join_team__';

/**
 * The team name a player gets if they start one and leave the name blank.
 *
 * Their own name, because a captain recognises it and can change it later. The
 * alternative — "Team 4", or nothing — is a name no one asked for that nobody
 * will fix, and it reads as a placeholder on the standings all season.
 */
export const defaultTeamName = (firstName, lastName) =>
  `${String(firstName || '').trim()} ${String(lastName || '').trim()}`.trim();

/**
 * The three team fields to send, from what the player picked.
 *
 * The server decides the name it actually stores — this sends the typed name
 * and lets registerForLeague apply the same fallback, so a blank box means the
 * same thing whichever page it was left blank on.
 */
export function teamChoiceFields(choice, typedName, joinTeamId) {
  if (choice === NEW_TEAM) {
    return { teamId: null, startTeam: true, newTeamName: String(typedName || '').trim() };
  }
  // Chose to join one but named none — the same outcome as free agent, which is
  // the point: the player is available and a captain can pick them up.
  if (choice === JOIN_TEAM) {
    return { teamId: joinTeamId || null, startTeam: false, newTeamName: '' };
  }
  if (choice === FREE_AGENT || !choice) {
    return { teamId: null, startTeam: false, newTeamName: '' };
  }
  // A raw team id, from the older one-entry-per-team dropdown. Still accepted
  // so a half-submitted form or an out-of-date tab does not break.
  return { teamId: choice, startTeam: false, newTeamName: '' };
}
